import useCompanySettings from './useCompanySettings';
import { QuoteReason } from '../types/settings';

const useQuoteReasons = (typeDocument: string): QuoteReason[] => (
  useCompanySettings(typeDocument === 'LOST' ? 'QUOTE_LOST_REASONS' : 'QUOTE_WON_REASONS', []) as QuoteReason[]
);

export default useQuoteReasons;
